<template>
  <section class="vr360-app">
    <main class="vr360-app-main vr360-wrap__inner">
      <div class="vr360-flex-column vr360-app-main__empty-state" style="height: 100%;">
        <div class="vr360-refresh" style="opacity: 0.5; transform: translate3d(0px, -100%, 0px);">
          <span class="vr360-refresh__circle">
            <svg
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                stroke-dasharray="30"
                stroke-dashoffset="30"
                cx="5"
                cy="5"
                r="4.5"
                stroke-width="1px"
                stroke="currentColor"
              ></circle>
            </svg>
          </span>
        </div>
        <i class="vr360-icon bg-watched-projects"></i>
        <p class="vr360-head-h1 vr360-text-gray-2">Open app on mobile device</p>
        <p class="vr360-head-h2 vr360-text-blue">{{ baseUrl }}</p>

        <p>
          <button
            type="button"
            class="vr360-btn vr360-btn--red"
            @click="saveAnswer">
            <span>View desktop anyway</span>
          </button>
        </p>
      </div>
    </main>
  </section>
</template>

<script>
export default {
  name: "openInMobile",
  methods: {
    saveAnswer() {
      localStorage.setItem("showOnDesktop", "1");
      window.location.reload();
    }
  },
  computed: {
    baseUrl() {
      return window.location.origin;
    }
  }
};
</script>
